import { render, staticRenderFns } from "./SimsComp.vue?vue&type=template&id=13c246c2&"
import script from "./SimsComp.vue?vue&type=script&lang=js&"
export * from "./SimsComp.vue?vue&type=script&lang=js&"
import style0 from "./SimsComp.vue?vue&type=style&index=0&id=13c246c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports